
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Mail, Phone, MapPin, Music } from 'lucide-react';
import { trackPhoneCallConversion } from '@/utils/trackPhoneCall';

const Contact = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-piano-black to-gray-900 text-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6">
              Kontakt Oscar Gilbert
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Kontakt mig for at høre nærmere om klaverundervisning.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div className="bg-gray-50 p-8 rounded-lg shadow-md">
              <h2 className="text-2xl font-serif font-semibold mb-6">Kontaktinformation</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <MapPin className="w-6 h-6 text-piano-gold mr-3 mt-0.5" />
                  <div>
                    <h3 className="font-medium">Adresse</h3>
                    <p className="text-gray-600">Niels Finsens Alle 86<br />2860 Søborg</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Mail className="w-6 h-6 text-piano-gold mr-3 mt-0.5" />
                  <div>
                    <h3 className="font-medium">Email</h3>
                    <a href="mailto:kontakt@pianoundervisning.dk" className="text-gray-600 hover:text-piano-gold">
                      kontakt@pianoundervisning.dk
                    </a>
                  </div>
                </div>
                <div className="flex items-start">
                  <Phone className="w-6 h-6 text-piano-gold mr-3 mt-0.5" />
                  <div>
                    <h3 className="font-medium">Telefon</h3>
                    <a href="tel:+4540817127" className="text-gray-600 hover:text-piano-gold" onClick={trackPhoneCallConversion}>
                      +45 40 81 71 27
                    </a>
                  </div>
                </div>
                <div className="flex items-start">
                  <Music className="w-6 h-6 text-piano-gold mr-3 mt-0.5" />
                  <div>
                    <h3 className="font-medium">Undervisningstider</h3>
                    <p className="text-gray-600">
                      Mandag: 9:00 - 17:00 & 19.30 - 21.30<br />
                      Tirsdag: 9:00 - 17:00<br />
                      Onsdag: 9:00 - 17:00 & 19.30 - 21.30<br />
                      Torsdag: 9:00 - 17:00<br />
                      Fredag: 9:00 - 15.30<br />
                      Lørdag: Lukket<br />
                      Søndag: Lukket
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Find vej */}
            <div className="bg-gray-50 p-8 rounded-lg shadow-md">
              <h2 className="text-2xl font-serif font-semibold mb-6">Find vej</h2>
              <div className="aspect-video bg-gray-200 rounded-lg mb-4 relative">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12607.679143124358!2d12.514096630724325!3d55.734728901797794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465251f89eae19fd%3A0x1029a319978e54b7!2sNiels%20Finsens%20Alle%2086%2C%202860%20S%C3%B8borg!5e0!3m2!1sda!2sdk!4v1743668909093!5m2!1sda!2sdk" 
                  width="100%" 
                  height="100%" 
                  style={{border:0}} 
                  allowFullScreen 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  className="absolute inset-0"
                ></iframe>
              </div>
              <div className="space-y-3 text-gray-600">
                <h3 className="font-medium text-black">Transport</h3>
                <p><strong>Med bus:</strong> Linje 6A er tættest på, men Linje 4A, 160, 164, 176 er også i nærheden.</p>
                <p><strong>Med tog:</strong> 15 minutters gang fra Vangede St. (1,1 km)</p>
                <p><strong>Med bil:</strong> Der er gratis parkering foran bygningen og i nærområdet.</p>
                <p><strong>Med cykel:</strong> Du kan sagtens parkere cyklen på adressen.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
